import type {
  Cause_Bool_Exp,
  GetCauseCountQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCauseCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

type CauseCountArgs = {
  // Resolved entity-filter selection — drives the tRPC path. Empty/absent ⇒
  // no entity filter.
  entityIds?: string[];
  // The equivalent Hasura bool_exp — drives the GraphQL fallback so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Cause_Bool_Exp;
};

export const useGetCauseCount = createQueryHook<
  CauseCountArgs,
  number,
  GetCauseCountQuery
>({
  trpcQueryOptions: (trpc, queryArgs) =>
    trpc.frontend.cause.causeCount.queryOptions({
      entityIds: queryArgs?.entityIds,
    }),
  // Pass the count straight through (not `data ?? 0`): the factory surfaces
  // undefined while loading, so a genuine 0 must stay 0.
  mapTrpcDataToGraphQL: (data) => ({
    cause_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetCauseCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
